// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1UOEn","left":"InfoRow_left__QL0cR"};